const slug = require('slug');

export function nameToSlug(name) {
  return slug(String(name).toString());
}

export function nameAndIdToUrl(id, name, preFix = "p") {
  return nameToSlug(name) + "-" + preFix + id + ".html";
}

export function urlToId(url, preFix = "p") {
  if (url) {
    let str = url.split('-').slice(-1).pop();
    if (str) {
      return parseInt(str.replace(preFix, "").replace(".html", ""));
    }
  }
  return false;
}